module.exports = __webpack_public_path__ + "images/m-interface_apple-80e162.png";